import React from "react";
import { useDispatch, useSelector } from "react-redux";

import { IgDialog } from "@intelligems/ig-theme";
import { ExperienceDto } from "@intelligems/ig-types";

import { isDialogOpen, setDialog } from "../../store/slices/global";

interface AdminOverrideStartExpDialogProps {
  experience: ExperienceDto;
  onExpButtonClick: (experiment: ExperienceDto) => void;
}
export const AdminOverrideStartExpDialog = ({
  onExpButtonClick,
  experience,
}: AdminOverrideStartExpDialogProps) => {
  const dispatch = useDispatch();
  const isOpen = useSelector(isDialogOpen("adminOverrideStartExp"));

  const handleClose = () => {
    dispatch(setDialog({ dialog: "adminOverrideStartExp", open: false }));
  };

  return (
    <IgDialog
      dialogTitleWidth={"350px"}
      title={
        "This store has NOT approved billing. Are you sure you want to start their experiment?"
      }
      handleClose={handleClose}
      showDialog={isOpen}
      handleYesClick={() => {
        onExpButtonClick(experience);
        handleClose();
      }}
      yesButtonText={"Yes"}
      shouldNotClose={true}
      dialogHeight={"250px"}
    />
  );
};
